import { LISTS_GROUP_BY_VALUE } from '@vlabs/monokit/entities/charts/chart-form';
import { UUID_PATTERN } from '@vlabs/shared/validators';

export const isUuidLabel = (value) => typeof value === 'string' && UUID_PATTERN.test(value);

// заменяем lists на top_matching_candidates_label
export const normalizeGroupByTargets = (groupByTargets = []) => {
  return groupByTargets.reduce((acc, target) => {
    if (target?.column === LISTS_GROUP_BY_VALUE) {
      acc.push({
        ...target,
        column: 'top_matching_candidates_label',
      });
      return acc;
    }

    acc.push(target);
    return acc;
  }, []);
};

// если выбран режим lists, оставляем только строки, где label это UUID
// если выбран режим top_matching_candidates_label, наоборот убираем UUID
// и подменяем имя поля в fields на lists, чтобы useChart взял лейбл Списки

export const processListsGroupByChartData = ({
  chartData,
  groupByTargets = [],
  listsById = {},
}) => {
  if (!chartData?.fields?.length || !chartData?.stats?.length) return chartData;

  const listsTarget = groupByTargets.find((target) => target?.column === LISTS_GROUP_BY_VALUE);
  const topMatchingTarget = groupByTargets.find((target) => target?.column === 'top_matching_candidates_label');

  if (!listsTarget && !topMatchingTarget) return chartData;

  const targetIndexes = chartData.fields.reduce((acc, field, index) => {
    if (field.includes("top_matching_candidates_label, aggregator 'group_by'")) {
      acc.push(index);
    }

    return acc;
  }, []);

  if (!targetIndexes.length) return chartData;

  const stats = chartData.stats
    .filter((row) => targetIndexes.every((index) => {
      const label = row[index];

      if (listsTarget) {
        return isUuidLabel(label);
      }

      if (topMatchingTarget) {
        return !isUuidLabel(label);
      }

      return true;
    }))
    .map((row) => {
      if (!listsTarget) return row;

      return row.map((value, index) => {
        if (!targetIndexes.includes(index)) return value;

        return listsById?.[value]?.user_data || value;
      });
    });

  const fields = chartData.fields.map((field) => {
    if (listsTarget && field.includes("top_matching_candidates_label, aggregator 'group_by'")) {
      return field.replace('top_matching_candidates_label', LISTS_GROUP_BY_VALUE);
    }

    return field;
  });

  return {
    ...chartData,
    fields,
    stats,
  };
};
